/*
* Copyright (C) Regione Lombardia
*/
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { environment } from '@env/environment';
import {
    RequestRilievoSearch,
    ResponseRilievo, Rilievo
} from '@models';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class RilievoService {

    private _rilievo: Rilievo;
    get rilievoSession() { return this._rilievo; }
    set rilievoSession(rilievo: Rilievo) { this._rilievo = rilievo; }

    constructor(
        private httpClient: HttpClient,
        private fb: FormBuilder
    ) { }

    public generateFormRilievo(values?: Rilievo): FormGroup {
        const criteriaForm = this.fb.group({
            idRilievo: this.fb.control(null),
            nome: this.fb.control(null, Validators.required),
            soggettoEsecutore: this.fb.control(null, Validators.required),
            descrizione: this.fb.control(null, Validators.required),
            importo: this.fb.control(null),
            estremiAttoIncarico: this.fb.control(null),
            flagAttivo: this.fb.control(null),
            dataInizioRilievo: this.fb.control(null, Validators.required),
            dataFineRilievo: this.fb.control(null)
        });
        if (values) {
            criteriaForm.patchValue(values);
        }
        return criteriaForm;
    }

    public generateFormRicercaRilievo(values?: RequestRilievoSearch): FormGroup {
        const criteriaForm = this.fb.group({
            idRilievo: this.fb.control(null),
            nome: this.fb.control(null),
            dataInizioRilievo: this.fb.control(null),
            dataFineRilievo: this.fb.control(null)
        });
        if (values) {
            criteriaForm.patchValue(values);
        }
        return criteriaForm;
    }

    /* Ricerca */
    public search(values: RequestRilievoSearch, paginatorQueryParams: string): Observable<ResponseRilievo> {
        return this.httpClient.post<ResponseRilievo>(`${environment.urlApi}/private/rilievo/ricerca?${paginatorQueryParams}`, values);
    }

    /* Rilievo: CRUD */
    public create(params: Rilievo): Observable<Rilievo> {
        return this.httpClient.post<Rilievo>(`${environment.urlApi}/private/rilievo`, params);
    }
    public read(idRilievo: number): Observable<Rilievo> {
        return this.httpClient.get<Rilievo>(`${environment.urlApi}/private/rilievo/${idRilievo}`);
    }
    public update(params: Rilievo): Observable<Rilievo> {
        return this.httpClient.put<Rilievo>(`${environment.urlApi}/private/rilievo`, params);
    }
    public delete(idRilievo: number) {
        return this.httpClient.delete(`${environment.urlApi}/private/rilievo/${idRilievo}`, { observe: 'response' });
    }


}
